// extracted by mini-css-extract-plugin
export default {"sectionRow":"CheckRowCount__sectionRow___vyiE6"};